const material = {
  state: {
    materialTypeList: [], // 根据项目仓库等有筛选的物料类别
    unitList: [] // 单位列表
  },
  getters: {
    materialTypeList: state => state.materialTypeList,
    unitList: state => state.unitList
  },
  mutations: {
    materialTypeList: (state, materialTypeList) => {
      state.materialTypeList = materialTypeList
    },
    unitList: (state, unitList) => {
      state.unitList = unitList
    }
  },
  actions: {
    handleMaterialTypeList (materialTypeList, data) {
      materialTypeList.commit('materialTypeList', data)
    },
    handleUnitList (unitList, data) {
      unitList.commit('unitList', data)
    }
  }
}

export default material
